import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './page/Home';
import BookList from './page/BookList';
import Events from './page/Events';
import AboutUs from './page/AboutUs';
import Team from './page/Team';
import Contact from './page/Contact';
import Membership from './page/Membership';
import Registration from './page/Registration';
import Header from './components/Header';
import Footer from './components/Footer';

const AppRoutes = () => {
  return (
    <div className="app-container">
      <Header />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/books" element={<BookList />} />
          <Route path="/events" element={<Events />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/team" element={<Team />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/registration" element={<Registration />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export default AppRoutes; 